export function renderLookup() {
  return `
    <div class="wrap">
      <div class="panel">
        <h1>Consultar ticket</h1>
        <p class="muted">Introduce el número de ticket y el email que usaste al crearlo.</p>
        <form id="lookup-form">
          <label for="ticket_number">Número de ticket</label>
          <input id="ticket_number" name="ticket_number" required maxlength="32" autocomplete="off" />
          <label for="requester_email">Email</label>
          <input id="requester_email" name="requester_email" type="email" required maxlength="255" autocomplete="email" />
          <div class="btn-row">
            <button class="btn" type="submit">Buscar</button>
            <a class="btn btn--ghost" data-link href="/">Nueva incidencia</a>
          </div>
        </form>
        <p id="lookup-msg" class="msg" role="status"></p>
      </div>
    </div>
  `
}

export function bindLookup({ navigate }) {
  const form = document.getElementById('lookup-form')
  const msg = document.getElementById('lookup-msg')
  form?.addEventListener('submit', async (ev) => {
    ev.preventDefault()
    msg.textContent = 'Buscando…'
    msg.className = 'msg'
    const fd = new FormData(form)
    try {
      const { lookupGuestTicket } = await import('../api.js')
      const data = await lookupGuestTicket({
        ticket_number: fd.get('ticket_number'),
        requester_email: fd.get('requester_email'),
      })
      const token = data.access_token
      if (token) {
        navigate(`/t/${token}`)
        return
      }
      msg.textContent = 'Ticket encontrado pero sin enlace.'
      msg.className = 'msg msg--err'
    } catch (e) {
      msg.textContent = e.message || 'No encontrado.'
      msg.className = 'msg msg--err'
    }
  })
}
